import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { core } from "@tauri-apps/api";

let clientPromise: null | Promise<SupabaseClient> = null;

/**
 * Erstellt (und cached) einen neuen Client aus aktueller Config.
 *
 * @returns Promise resolving to SupabaseClient instance
 *
 */
async function initClient(): Promise<SupabaseClient> {
  const { 0: url, 1: key } = await core.invoke<[string, string]>("get_supabase_config_cmd");
  return createClient(url, key);
}

/**
 * Gibt einen Supabase-Client zurück, der die Credentials zur Laufzeit vom Backend lädt (via Tauri IPC).
 *
 * @returns Promise resolving to SupabaseClient instance
 *
 */
export async function getSupabaseClient(): Promise<SupabaseClient> {
  clientPromise ??= initClient();
  return clientPromise;
}

/**
 * Resettet den Client (wird nach Änderung der Config benötigt).
 */
export function resetSupabaseClient(): void {
  clientPromise = null;
}
